function redirectIfNotInFrame() {
	if (window.self === window.top) {
		window.location = `${window.appData.appPath}/signin`;
	}
}

export default redirectIfNotInFrame;
